import evomap from "../../../assets/images/logo-evomap.png";

export const FooterDev = () => {

  return (
    <div className="footer-dev">
      <a href="https://evomap.com.br" target="_blank" rel="noopener noreferrer">
        <img src={evomap} alt="EVOMAP" />
      </a>
    </div>
  );
};